<!--
  @component CodeScreen — the in-browser code editor (Tier 2 v1).
  tier:      screen (per-project — `/projects/:id/code`)
  reads:     useIdentityIO → currentProject; renders CodeWorkspace.
  scope:     edit files → commit → the build vertical builds + deploys. The
             code-editor engine (document model, diff, Monaco, LSP, AI) is the
             planned drop-in upgrade on top of this surface.
-->
<script lang="ts">
  import { useIdentityIO } from "../../accounts/IdentityIO.svelte";
  import CodeWorkspace from "../../editor/CodeWorkspace.svelte";
  import GitPanel from "../../editor/GitPanel.svelte";

  const identity = useIdentityIO();
  const project = $derived(identity.currentProject);
</script>

{#if !project}
  <div class="notfound"><h1>Project not found</h1><p>This URL doesn't match a project you own.</p></div>
{:else}
  <div class="screen">
    <header class="head">
      <h1>Code</h1>
      <p class="sub">Edit your project's files in the browser, commit, and ship.</p>
    </header>
    <CodeWorkspace projectId={project.id} />
    <GitPanel projectId={project.id} />
  </div>
{/if}

<style>
  .screen { display: flex; flex-direction: column; gap: var(--space-5); max-width: 1040px; font-family: var(--type-font); }
  .head h1 { margin: 0 0 var(--space-2); font-size: 24px; font-weight: 600; letter-spacing: -0.025em; color: var(--text-primary); }
  .sub { margin: 0; font-size: 13.5px; color: var(--text-secondary); }
  .notfound { max-width: 460px; }
  .notfound h1 { margin: 0 0 var(--space-3); font-size: 20px; font-weight: 600; color: var(--text-primary); }
  .notfound p { margin: 0; font-size: 13.5px; color: var(--text-secondary); }
</style>
